/* 法语 */
export default {
  route:{
  "title": "Système de publication d'informations",
    "home": "Accueil",
    "terminal": "Terminal",
    "program": "Programme",
    "h5program": "Programme",
    "my": "Mon",
    "remote_control": "Télécommande",
    "task_details": "Détails de la tâche",
    "add_task": "Ajouter une tâche",
    "program_list": "Liste des programmes",
    "terminal_info": "Informations sur le terminal",
    "add_resolution": "Ajouter une résolution",
    "add_program": "Ajouter un programme",
    "material_management": "Gestion des matériaux",
    "create_program": "Nouveau programme",
    "login": "Connexion",
    "reset_password": "Réinitialiser le mot de passe",
    "change_password": "Changer le mot de passe",
    "preview": "Aperçu"
  },
  append_field:{
 "input_code": "Veuillez entrer le code de vérification",
    "code_error": "Code de vérification incorrect",
    "fill_code": "Veuillez remplir le code de vérification",
    "dOut": "Rotation 3D sortante",
    "dIn": "Rotation 3D entrante",
    "dxiao": "Effet cadre 3D",
    "selectImage": "Veuillez sélectionner une image",
    "onlySelectOneImage": "Vous ne pouvez sélectionner qu'une seule image",
    "imageFormatError": "Erreur de format d'image",
    "cancel": "Annuler",
    "selectedNumber": "Sélectionné",
    "confirm": "Confirmer",
    "loadinga": "Chargement en cours...",
    "loadingb": "Chargement en cours",
    "uploading": "Téléchargement en cours",
    "selectStartDates": "Sélectionner la date de début",
    "selectEndDates": "Sélectionner la date de fin",
    "createTask": "Créer une tâche",
    "selectPrograms": "Sélectionner des programmes",
    "createPrograms": "Nouveau programme",
    "editTask": "Modifier la tâche",
    "fillTaskName": "Veuillez entrer le nom",
    "selectTaskGroup": "Veuillez sélectionner un groupe de tâches",
    "selectProgram": "Veuillez sélectionner un programme",
    "selected": "Sélectionné",
    "programs": "programmes",
    "selectDevice": "Veuillez sélectionner un appareil",
    "sendTaskSuccess": "Tâche envoyée avec succès",
    "taskName": "Nom",
    "playMode": "Mode de lecture",
    "replaceMode": "Mode de remplacement",
    "appendMode": "Mode Ajout",
    "apotpatterns": "Mode Intercale",
    "dateRange": "Date de lecture",
    "timeRange": "Date de début",
    "taskPeriod": "Spécifiez la semaine",
    "mon": "Lun",
    "tue": "Mar",
    "wed": "Mer",
    "thu": "Jeu",
    "fri": "Ven",
    "sat": "Sam",
    "sun": "Dim",
    "back": "Retour",
    "programList": "Liste des programmes",
    "deviceList": "Liste des appareils",
    "enterContent": "Veuillez entrer le contenu",
    "taskGroup": "Groupe de tâches",
    "selectStartDate": "Veuillez sélectionner la date de début",
    "selectEndDate": "Veuillez sélectionner la date de fin",
    "selectStartTime": "Veuillez sélectionner l'heure de début",
    "selectEndTime": "Veuillez sélectionner l'heure de fin",
    "addTask": "Ajouter une tâche",
    "topLeft": "En haut à gauche",
    "topCenter": "En haut au centre",
    "topRight": "En haut à droite",
    "leftCenter": "Aligné à gauche au centre",
    "center": "Centré",
    "rightCenter": "Aligné à droite au centre",
    "bottomLeft": "En bas à gauche",
    "bottomCenter": "En bas au centre",
    "bottomRight": "En bas à droite",
    "enterText": "Veuillez entrer le texte",
    "fontColor": "Couleur la police",
    "bgColor": "Couleur Arrière-plan",
    "scrollDirection": "Sens du défilement",
    "scrollSpeed": "Vitesse de défilement",
    "fontSize": "Police",
    "alignment": "Alignement",
    "subtitle": "Sous-titre",
    "enterURL": "Veuillez entrer l'URL",
    "webPage": "Web",
    "enterMediaURL": "Veuillez entrer l'URL du média",
    "media": "Streaming",
    "selectVideo": "Veuillez sélectionner une vidéo",
   unsupportedFormat: 'Format de fichier non pris en charge. Pour les formats pris en charge détaillés, veuillez consulter Mon - Aide du système.',
   "cancelAllSelections": "Veuillez d'abord annuler toutes les sélections avant de télécharger de nouveaux fichiers",
  "fileName": "Nom du fichier",
  "fileSize": "Taille du fichier",
  "uploadProgress": "Progression du téléchargement",
  "cancelUpload": "Annuler le téléchargement",
  "cancelAllUploads": "Annuler tous les téléchargements",
  "leftToRights": "De gauche à droite",
  "rightToLefts": "De droite à gauche",
  "bottomToTops": "De bas en haut",
  "static": "Statique",
  "slow": "Lent",
  "medium": "Moyen",
  "fast": "Rapide",
  "colorValue": "Valeur de la couleur",
  "defaultEffect": "Effet par défaut",
  "rightToLeft": "Droite à gauche",
  "leftToRight": "Gauche à droite",
  "topToBottom": "Haut en bas",
  "bottomToTop": "Bas en haut",
  "accordionSqueeze": "Accordéon compressé",
  "zoomInFade": "Zoom avant fondu",
  "zoomOutFade": "Zoom arrière fondu",
  "depthOfField": "Profondeur de champ",
  "leftRightRotate": "Rotation gauche droite",
  "upDownRotate": "Rotation haut bas",
  "counterclockwiseRotate": "Rotation antihoraire",
  "clockwiseRotate": "Rotation horaire",
  "upDownZoom": "Zoom haut bas",
  "scaleFade": "Échelle fondu",
  "zoomInDisappearing": "Zoom avant disparition",
  "transparentFade": "Fondu transparent",
  "gradientScale": "Échelle graduée",
  "deleteMaterial": "Supprimer le matériel",
  "confirmDeleteMaterial": "Confirmer la suppression de ce matériel?",
  "unreviewed": "Non examiné",
  "normal2": "Normal",
  "violating": "En infraction",
  "suspectedViolating": "Suspecté d'infraction",
  "delete": "Supprimer",
  "selectMaterial": "Veuillez sélectionner le matériel",
  "deleteProgramGroup": "Supprimer le groupe de programmes",
  "confirmDeleteGroup": "Confirmer la suppression de ce groupe?",
  "add": "Ajouter",
  "toggle_effect": "Changer d'effet",
  "toggle_time": "Changer de temps",
  "pub_toggle_time": "Temps de transition",
  "fullscreen": "Plein écran",
  "normal": "Normal",
  "interactive": "Interactif",
  "main_screen": "Écran principal",
  "sub_screen": "Écran secondaire",
  "dual_screen": "Double écran",
  "sync_task": "Tâche de synchronisation",
  "normal_mode": "Mode normal",
  "basic_info": "Informations de base",
  "program_info": "Détails de la tâche",
  "task_name": "Nom de la tâche",
  "task_type": "Type de tâche",
  "pub_task": "Tâche ordinaire",
  "hu_task": "Tâche interactive",
  "no_data": "Pas de données",
  "no_msg": "Pas de message",
  "program_name": "Nom du programme",
  "program_resolution": "Résolution du programme",
  "program_type": "Type de programme",
  "screen_category": "Catégorie d'écran",
  "edit_program": "Modifier le programme",
  "edit": "Modifier",
  "send": "Envoyez",
  "create": "Créer un groupe",
  "reload": "Recharger",
  "name": "Nom",
  "create_task_z": "Créer un groupe de tâches",
  "ps_push_name": "Veuillez entrer le nom du groupe",
  "device_list": "Liste des appareils",
  "delete_task_group": "Supprimer le groupe de tâches",
  "confirm_delete_group": "Confirmer la suppression de ce groupe?",
  "delete_success": "Suppression réussie",
  "name_cannot_be_empty": "Le nom ne peut pas être vide",
  "character_length_limit": "La longueur des caractères doit être inférieure à 10",
  "create_task_success": "Création de la tâche réussie",
  "create_task_failed": "Échec de la création",
  "confirm_delete_task": "Confirmer la suppression de la tâche?",
  "task_details": "Détails de la tâche",
  "download_success": "Téléchargement réussi",
  "waiting_download": "En attente de téléchargement",
  "downloading": "Téléchargement en cours",
  "confirm_delete": "Confirmer la suppression?",
  "confirm_delete_all": "Confirmer la suppression de tous?",
  "confirm_delete_selected": "Confirmer la suppression des éléments sélectionnés?",
  "no_data_to_clear": "Aucune donnée à effacer!",
  "refresh": "Actualisez",
  "clear_all": "Tout effacer",
  "clear_completed": "Effacez les éléments terminés",
  "device_id": "ID de l'appareil",
  "task_size": "Taille de la tâche",
  "speed": "Vitesse",
  "download_progress": "Progression du téléchargement",
  "title": "Titre",
  "volume": "Volume",
  "deleteP": "Supprimer le programme",
  "con_P": "Confirmer la suppression de ce programme?",
  "clear": "Effacez",
  "download_status": "Statut du téléchargement",
  "height_width_cannot_be_empty": "La hauteur/la largeur ne peuvent pas être vides",
  "add_success": "Ajout réussi",
  "enter_number_between_300_to_8000": "Veuillez entrer un nombre entre 300 et 8000",
  "width": "Largeur",
  "enter_width": "Veuillez entrer la largeur",
  "height": "Hauteur",
  "enter_height": "Veuillez entrer la hauteur",
  "confirm_leave_page": "Confirmer le départ de cette page?",
  "add_content_to_control": "Veuillez ajouter du contenu au contrôle",
  "add_control": "Veuillez ajouter un contrôle",
  "save_success": "Sauvegarde réussie",
  "save": "Enregistrez",
  "create_program": "Nouveau programme",
  "guess": "Devinez",
  "modify": "Modifier",
  "text": "Texte",
  "image": "Image",
  "background_image": "Image de fond",
  "background_music": "Musique de fond",
  "replace": "Remplacer",
  "use_this_template": "Utiliser ce modèle",
  "apply_template": "Appliquer le modèle",
  "enter_program_name": "Veuillez entrer le nom du programme",
  "program_group": "Groupe de programmes",
  "select_program_group": "Veuillez sélectionner un groupe de programmes",
  "group_list": "Liste de groupes",
  "preview": "Aperçu",
  "my_apps": "Mes applications",
  "template_center": "Centre de modèles",
  "home": "Accueil",
  "source_of_visit": "Source de visite",
  "online": "En ligne",
  "terminal_status": "Statut",
  "memory_status": "Statut de la mémoire",
  "login": "Connexion",
  "sms_verification": "Vérification par SMS",
  "email_verification": "Vérification par email",
  "log_in": "Connexion",
  "enter_username": "Veuillez entrer le nom d'utilisateur",
  "username_cannot_be_empty": "Le nom d'utilisateur ne peut pas être vide",
  "password_cannot_be_empty": "Le mot de passe ne peut pas être vide",
  "incorrect_phone_format_for_verification_code": "Le format du numéro de téléphone pour le code de vérification est incorrect, veuillez contacter l'administrateur pour le modifier!",
  "incorrect_email_format_for_verification_code": "Le format de l'email pour le code de vérification est incorrect, veuillez contacter l'administrateur pour le modifier!",
  "incorrect_phone_or_email_format_for_verification_code": "Le format de l'email ou du téléphone pour le code de vérification est incorrect, veuillez contacter l'administrateur pour le modifier!",
  "reset_password": "Réinitialiser le mot de passe",
  "remember_password": "Se souvenir du mot de passe",
  "register": "Enregistrer un compte",
  "current_version_4.1.6": "V4.1.8",
  "notification_about_network_security": "Notification sur la sécurité du réseau",
  "got_it": "Compris",
  "please_authenticate_for_account_safety": "Pour la sécurité de votre compte, veuillez vous authentifier",
  "enter_account": "Veuillez entrer le compte",
  "enter_password": "Veuillez entrer le mot de passe",
  "verification_code": "Code de vérification",
  "none": "Aucun",
  "personal_center": "Centre personnel",
  "remote_control": "Télécommande",
  "refresh_success": "Rafraîchissement réussi!",
  "logout": "Se déconnecter",
  "confirm_logout": "Êtes-vous sûr de vouloir vous déconnecter?",
  "user_status": "Statut de l'utilisateur",
  "customer_address": "Adresse du client",
  "account_period": "Période du compte",
  "device_control": "Contrôle de l'appareil",
  "clear_cache": "Vider le cache",
  "exit": "Quitter",
  "terminal": "Terminal",
  "program": "Programme",
  "material": "Matériel",
  "my": "Mon",
  "display_type": "Type d'affichage",
  "proportion": "Échelle",
  "resolution": "Résolution",
  "screen_orientation": "Orientation de l'écran",
  "landscape": "Horizontal",
  "portrait": "Vertical",
  "add_resolution": "Ajouter une résolution",
  "execute_formatting_when_focus_lost": "Exécuter le formatage lorsque le focus est perdu",
  "select_resolution": "Veuillez sélectionner une résolution",
  "resolution_list": "Liste des résolutions",
  "confirm_delete_program": "Êtes-vous sûr de vouloir supprimer le programme?",
  "confirm_delete_this_program": "Êtes-vous sûr de vouloir supprimer ce programme?",
  "bound_tasks_exists_confirm_delete": "Des tâches sont liées, êtes-vous sûr de vouloir supprimer?",
  "prompt": "Prompt",
  "delete_failed": "Échec de la suppression",
  "modification_time": "Heure de modification",
  "resolution_": "Résolution",
  "associated_tasks": "Tâches associées",
  "bound_task": "Tâche liée",
  "program_management": "Gestion des programmes",
  "task": "Tâche",
  "progress": "Progression",
  "phone_number": "Numéro de téléphone",
  "enter_phone_number": "Veuillez entrer le numéro de téléphone",
  "password": "Mot de passe",
  "confirm_password": "Confirmer le mot de passe",
  "enter_password_again": "Veuillez entrer à nouveau le mot de passe",
  "company_name": "Nom de l'entreprise",
  "enter_company_name": "Veuillez entrer les informations de votre entreprise",
  "address": "Adresse",
  "enter_address": "Veuillez entrer l'adresse de contact",
  "username_not_exist": "Le nom d'utilisateur n'existe pas",
  "enter_new_password": "Veuillez entrer un nouveau mot de passe",
  "enter_new_password_again": "Veuillez entrer à nouveau le nouveau mot de passe",
  "terminal_management": "Gestion des terminaux",
  "delete_group": "Supprimer le groupe",
  "pel_select_group": "Veuillez sélectionner un groupe",
  "enter_device_name": "Veuillez entrer le nom de l'appareil",
  "delete_device": "Supprimer l'appareil",
  "confirm_delete_device": "Êtes-vous sûr de vouloir supprimer cet appareil?",
  "terminal_information": "Informations sur le terminal",
  "qr_code_error": "Erreur de code QR",
  "device_not_supported": "Appareil non supporté",
  "device_offline": "L'appareil sélectionné doit être en ligne pour envoyer des commandes, veuillez réessayer!",
  "more": "Plus",
  "device_access": "Accès à l'appareil",
  "filter": "Filtrer",
  "all": "Tout",
  "offline": "Hors ligne",
  "device_name": "Nom de l'appareil",
  "device_number": "Numéro de l'appareil",
  "device_group": "Groupe d'appareils",
  "call_device_please_wait": "Appel de l'appareil, veuillez patienter...",
  "create_terminal_group": "Créer un groupe de terminaux",
  "enter_search_keyword": "Veuillez entrer un mot-clé de recherche",
  "bind_device": "Lier l'appareil",
  "select_device_group": "Veuillez sélectionner un groupe d'appareils",
  "authorized": "Autorisé",
  "unauthorized": "Non autorisé",
  "adjust_volume": "Régler le volume",
  "reboot_device": "Redémarrer l'appareil",
  "wake_up": "Réveiller",
  "sleep": "Hiberner",
  "shutdown": "Éteindre",
  "clean_up_timing_on_off": "Éliminez la minuterie",
  "clean_up_disk": "Éliminez le disque",
  "clean_up_task": "Éliminez les tâches",
  "send_command": "Envoyer la commande",
  "confirm2": "Êtes-vous sûr d'envoyer-",
  "terminal_operation": "Opération terminale",
  "bind_task": "Informations sur la tâche",
  "remote_command": "Commande à distance",
  "remote_monitor": "Surveillance à distance",
  "adding_one_will_override_the_previous": "Ajouter un seul enregistrement de minuterie est autorisé",
  "screenshot_in_progress_please_wait": "Capture d'écran en cours, veuillez patienter",
  "schedule_on_off": "Marche/arrêt programmée",
  "shutdown_time": "Heure d'extinction",
  "startup_time": "Heure de démarrage",
  "volume_setting": "Réglage du volume",
  "edit_device_name": "Modifier le nom de l'appareil",
  "please_select_time": "Veuillez sélectionner une heure",
  "device_not_online_please_retry": "Appareil hors ligne, veuillez réessayer",
  "sent_successfully": "Envoi réussi",
  "version": "V4.1.8",
  "texta": "Texte",
  "userName": "Compte",
  "email": "Email",
  "device_memory": "Mémoire de l'appareil",
  "device": "Appareil",
  "device_mac": "MAC de l'appareil",
  "screen_count": "Nombre d'écrans",
  "device_location": "Localisation de l'appareil",
  "is_authorized": "Est autorisé",
  "remark": "Remarque",
  "device_ip": "IP de l'appareil",
  "system_version": "Version du système",
  "playback_date": "Date de lecture",
  "playback_period": "Période de lecture",
  "retrieve_again": "Récupérer à nouveau",
  "please_enter_password": "Veuillez entrer un mot de passe de plus de 8 caractères contenant des chiffres, des lettres et des caractères spéciaux [@#$%^&+=]!",
  "passwords_do_not_match": "Les mots de passe ne correspondent pas",
  "enter_new_password2": "Entrer un nouveau mot de passe",
  "current_password_too_simple": "Le mot de passe actuel est trop simple, pour protéger la sécurité de votre compte, veuillez le modifier dès que possible, en entrant un mot de passe de plus de 8 caractères contenant des chiffres, des lettres et des caractères spéciaux [@#$%^&+=]",
  "creation_time": "Heure de création",
  "login2": "Connexion",
  "welcome": "Bienvenue",
  "expired_login": "La vérification de l'identité a expiré, veuillez vous reconnecter.",
  "control": "Télécommande",
  "add_task": "Ajouter une tâche",
  "program_list": "Liste des programmes",
  "terminal_info": "Informations sur le terminal",
  "add_program": "Ajouter un programme",
  "material_management": "Gestion des matériaux",
  "change_password": "Changer le mot de passe",
  "enter_text_content": "Veuillez entrer le contenu du texte",
  "hit_the_wall_on_back": "Il y a un mur derrière",
  "last_ceremony": "Dernière cérémonie",
  "already_top_level": "Déjà au niveau supérieur",
  "already_last_one": "Déjà la dernière fois",
   "white_fox": "Renard blanc",
  "control_img": "Image",
  "control_video": "Vidéo",
  "control_streaming": "Streaming",
  "control_webPage": "Site web",
  "control_subtitle": "Texte",
  "control_HDMI": "HDMI",
  "control_addbackground": "Arrière-plan",
  "Up": "Télécharger",
  "onlyOne": "Un seul contrôle peut être ajouté",
  "clearBg": "Effacez l'arrière-plan",
  "get_code": "Veuillez d'abord entrer le code de vérification",
  "del_Null_Program": "Voulez-vous vider la liste des programmes vides?",
  "please_select_date": "Veuillez sélectionner au moins une date",
  "last_size": "Espace restant",
  "shutdown_tips": "Après l'arrêt, le redémarrage à distance n'est pas possible",
  "last_size_upload": "Veuillez sélectionner à nouveau.",
  "end_date_earlier_than_start_date": "La date de fin ne peut pas être antérieure à la date de début",
  "account_type": "Type d'utilisateur",
  "user_type": "Utilisateur normal",
  "role_type": "Rôle",
  "super_administrator": "Super administrateur",
  "term_info_empty": "Informations sur le terminal vides",
  "select_terminal_prompt": "Veuillez cliquer sur le bouton de la liste en haut à droite pour sélectionner un terminal",
  "select": "Sélectionner",
  "data_empty": "Pas de données!",
  "content_review": "Révision du contenu",
  "start_date": "Date de début",
  "end_date": "Date de fin",
  "start_time": "Heure de début",
  "end_time": "Heure de fin",
  "select_all": "Tout sélectionner",
  "select_group": "Sélectionner un groupe",
  "review": "Réviser",
  "material_type": "Type de matériel",
  "audio": "Audio",
  "document": "Document",
  "material_status": "Statut du matériel",
  "material_review": "Révision du matériel",
  "current_selection_requires_review": "Le matériel sélectionné actuellement nécessite-t-il une révision?",
  "invCode": "Code d'invitation",
  "tip_invitation_empty": "Veuillez entrer le code d'invitation",
  "enter_userName": "Veuillez entrer le compte utilisateur",
  "enter_email": "Veuillez entrer l'email",
  "file_less_38": "Fichier inférieur à 1kb",
  "viewError": "Ce fichier ne prend pas en charge l'aperçu",
  "user": "Informations personnelles",
  "phone_number_too_short": "Le numéro de téléphone doit comporter plus de 9 chiffres",
  "oneImage": "L'image de fond existe déjà. Pour en télécharger une nouvelle, veuillez d'abord supprimer l'ancienne",
  "del_title": "Confirmer la suppression",
  "del_message": "Êtes-vous sûr de vouloir supprimer le contrôle?",
  "close": "Fermer",
  "exit_group_name": "Modifier le nom du groupe",
  "group_management": "Gestion des groupes",
  "language": "Changer de langue",
  "mixture": "Mixte",
  "date": "Date",
  "weeks": "Semaine",
  "time": "Temps",
  "new_password": "Nouveau mot de passe",
  "enter_invCode": "Conseil: Veuillez demander le code d'invitation à votre administrateur supérieur",
  "msg_password": "Conseil: Veuillez entrer un mot de passe de plus de 8 caractères contenant des chiffres, des lettres et des caractères spéciaux [@#$%^&+=]!",
  "oneDoc": "Le document existe déjà. Pour en télécharger un nouveau, veuillez d'abord supprimer l'ancien",
  "Sunday": "Dimanche",
  "Monday": "Lundi",
  "Tuesday": "Mardi",
  "Wednesday": "Mercredi",
  "Thursday": "Jeudi",
  "Friday": "Vendredi",
  "Saturday": "Samedi",
  "input_error": "Tous les champs du formulaire ne peuvent pas être vides",
  "video_tutorial": "Matériel",
  "view": "Regarder en ligne",
  "selectDeviceOne": "Cette commande ne peut sélectionner qu'un seul appareil pour la requête",
  "select_device_list": "Liste des appareils sélectionnés",
  "small_size": "Petit",
  "medium_size": "Moyen",
  "large_size": "Grand",
  "device_info": "Détails de l'appareil",
  "notification": "Notification",
  "notif_title": "Contenu de la notification",
  "notif_msg": "À partir du 5 novembre 2024, le centre de service ETV supprimera tous les matériaux stockés depuis plus d'un an. Veuillez sauvegarder vos matériaux importants à l'avance. Merci de votre compréhension et de votre coopération.",
  "reduce": "Réduire",
  "bound_material": "Matériel lié",
  "tip_material": "Le matériel lié à un programme ne peut pas être supprimé. Veuillez d'abord dissocier le matériel",
  "boundpo": "Programme lié",
  "bind_progron": "Ce matériel est lié à un programme et ne peut pas être supprimé",
  "index": "Indice",
  "source": "Source",
  "getUploadSet_tip": "Échec de la récupération des paramètres de téléchargement du matériel",
  "getUploadstartTime_tip": "Le téléchargement de matériel est interdit à l'heure actuelle. Veuillez télécharger en dehors des heures interdites",
  "getUploadendTim": "Téléchargement de matériel interdit",
  "download": "Télécharger",
  "network_import": "Importation réseau",
  "mobile_mode": "Mode mobile",
  "standalone_mode": "Mode autonome",
  "network_connection": "1. Connexion réseau",
  "network_methods": "Il existe deux méthodes de connexion réseau:",
  "network_method_1": "(1) Paramètres → Réseau et Internet → WLAN → Se connecter au réseau → Après la connexion au réseau, ouvrir ETV → L'icône réseau devient blanche, connexion réussie.",
  "network_method_2": "(2) Ouvrir ETV → Clic droit → Paramètres du logiciel → Sélectionner importation réseau, cliquer sur Suivant → Paramètres de propriété → Paramètres Wi-Fi → Aller à l'écran de connexion Wi-Fi, se connecter au réseau → Retourner à l'écran précédent → Retourner à l'écran principal d'ETV → L'icône réseau devient blanche, connexion réussie.",
  "account_registration": "2. Enregistrement de compte",
  "registration_methods": "Il existe deux méthodes d'enregistrement:",
  "registration_method_1": "(1) Compte attribué par un supérieur: Le supérieur se connecte → Gestion des clients → Ajouter un client → Remplir les informations du client et confirmer → Création réussie, le compte apparaît dans la liste des clients.",
  "registration_method_2": "(2) Enregistrement libre: Page de connexion du serveur → Enregistrer un compte → Remplir les informations et soumettre → Enregistrement réussi.",
  "invitation_code_source": "Source du code d'invitation: Le supérieur se connecte → Configuration du système → Gestion des codes d'invitation → Ajouter un code d'invitation.",
  "device_connection": "3. Connexion de l'appareil",
  "device_connection_steps": "Ouvrir ETV → Clic droit → Paramètres du logiciel → Sélectionner importation réseau, cliquer sur Suivant → Entrer l'adresse du serveur (adresse du serveur de connexion), le port de contrôle (par défaut 8899), le nom d'utilisateur (compte attribué ou enregistré) → Cliquer sur Connexion → Connexion réussie, l'appareil apparaît dans la liste des appareils du backend.",
  "connect_terminal": "1. Connecter un appareil terminal",
  "scan_qr_code": "1. Scanner le code QR en haut à gauche: Scanner le code QR du terminal pour connecter l'appareil.",
  "device_List": "2. Liste des appareils en haut à droite: La liste affiche tous les appareils du réseau local, sélectionner les appareils.",
  "remote_Command": "2. Commande à distance",
  "send_Command": "Envoyer une commande à l'appareil terminal, l'appareil exécutera la commande correspondante",
  "quick_send_program": "3. Envoi rapide de programme",
  "quick_send_steps": "Envoyer une commande de démonstration rapide → Obtenir du matériel local (images, vidéos, documents), sélectionner le matériel et confirmer → Définir le temps de lecture du programme et confirmer → Programme envoyé avec succès.",
  "program_creation": "4. Création de programme",
  "new_program": "1. Créer un nouveau programme: Entrer au moins deux caractères pour le nom du programme (le nom est généré automatiquement en fonction de l'heure de création), sélectionner l'orientation de l'écran et le type d'affichage, après la création réussie, passer à l'écran d'édition du programme.",
  "program_editing": "2. Édition de programme: Sélectionner le mode de lecture du programme (remplacement, insertion, ajout), cliquer sur «<img src='/static/images/help/icon.png' alt='' />» pour ajouter des contrôles (image, vidéo, lecture mixte, documents, etc.), ajuster librement la taille et la position des contrôles, cliquer sur «<img src='/static/images/help/icon_2.png' alt='' />» pour ajouter du matériel, en bas, définir diverses propriétés des contrôles.",
  "program_sending": "5. Envoi de programme",
  "send_program_steps": "Créer le programme → Cliquer sur Envoyer → La liste des appareils s'affiche, sélectionner les appareils → Cliquer sur Confirmer → Passer à l'écran de progression du téléchargement, afficher la progression → À 100%, afficher Terminé → L'appareil joue le programme envoyé.",
  "simple_mode_title": "1. Mode simple (par défaut)",
  "simple_mode_description": "Ce mode est la méthode d'importation par défaut pour les appareils autonomes. Il suffit de placer les images et les vidéos dans le répertoire racine de la clé USB, puis d'insérer la clé USB dans l'appareil principal pour terminer l'importation.",
  "simple_mode_note": "(Remarque: ne prend en charge que l'importation d'images et de vidéos, pour d'autres scénarios, veuillez utiliser la deuxième méthode pour les appareils autonomes)",
  "regular_mode_title": "2. Mode régulier",
  "regular_mode_description": "Sélectionner le mode autonome et cliquer sur Suivant, l'écran du mode autonome s'affiche (voir ci-dessous)",
  "regular_mode_steps": "1. Accéder aux paramètres de mise en page de l'écran principal<br>2. Accéder aux paramètres de mise en page de l'écran secondaire",
  "step_one": "Étape 1:",
  "step_one_description": "Insérer la clé USB, créer un dossier «etv-media» dans le répertoire racine, créer un dossier «main» dans le dossier etv-media, pour les tâches à double écran, créer un dossier «double» dans le dossier etv-media",
  "step_two": "Étape 2:",
  "step_two_description": "En fonction des paramètres de mise en page de l'écran principal ou secondaire, créer des dossiers 1/2/3/4 dans le dossier main ou double",
  "step_three": "Étape 3:",
  "step_three_description": "Copier les images/vidéos dans les dossiers 1/2/3/4 correspondants dans le dossier main ou double",
  "step_four": "Étape 4:",
  "step_four_description": "Prend en charge la lecture en plein écran des documents PDF, un seul document est autorisé",
  "step_five": "Étape 5:",
  "step_five_description": "Les fichiers audio doivent être placés dans le répertoire MAIN/DOUBLE, le système passera automatiquement d'un fichier à l'autre",
  "play_order_title": "Ordre de lecture:",
  "play_order_description": "1: Les fichiers nommés par des chiffres sont lus en premier, dans l'ordre croissant<br>2: Les fichiers nommés par des lettres sont lus ensuite, dans l'ordre alphabétique<br>3: Les fichiers nommés par des caractères chinois sont lus en dernier, dans l'ordre alphabétique du premier caractère",
  "document_playback_note": "Lecture de documents (activée par défaut): Sur les cartes mères 3128 et M11, l'affichage des documents est désactivé par défaut (pour optimiser les performances), il doit être activé manuellement",
   program_review: 'Révision du programme',
   pass: 'Passer',
   not_passed_or_not_reviewed: 'Non passé ou non examiné',
   play_mode: 'Mode de lecture',
   review_status: 'Statut de révision',
   reject: 'Rejeter',
   review_content: 'Contenu de la révision',
   enter_review_content: 'Veuillez entrer le contenu de la révision',
   device_quantity: "Quantité d'appareils",
   system_help: 'Aide du système',
   updateInfo: 'Informations de mise à jour',
   Formatspecification: 'Spécification de format',
   fileFormat: 'Format de fichier',
   imgFormat: 'Format d\'image',
   audioFormat: 'Format audio',
   videoFormat: 'Format vidéo',
   updated: 'Date de mise à jour',
   details: '1: Ajout du menu Mon - Aide du système<br>2: Ajout de nouveaux types de matériel de téléchargement, téléchargement Tencent Cloud, synchronisation avec les paramètres du PC<br>3: Optimisation de l\'affichage des matériaux et des programmes',
   "nameLengthLimit": "Veuillez limiter la longueur du nom à 50 caractères.",
   "customer_title": "Requête de compte",
   "authorized_devices": "Appareils autorisés",
   "enable": "Activer",
   "disable": "Désactiver",
   "expired": "Compte expiré",
   "valid_date": "Date de validité",
   "valid_date_placeholder": "Saisir la date de validité",
   "capacity_rule": "La capacité du serveur doit être un multiple de 100",
   "capacity_label": "Capacité du serveur (Mo)",
   "download_speed": "Limite de vitesse de téléchargement",
   "submit_btn": "Soumettre",
   "sub_accounts":"Seuls les sous-comptes sont modifiables",
   plan_mode: 'Mode Plan',
   default_mode: 'Mode Par Défaut',
   "noMore": "Pas plus",
   "help": "Aide d'utilisation",
   "apk_download": "Téléchargement APK",
   "android": "Android",
   "ios": "iOS",
   "app_name": "Assistant de Publication d'Informations ETV-H5",
   "info_publish": "Publication d'Informations",
   "upload_material": "Télécharger du Matériel",
   "img_size": "Exception de pixel d'image, veuillez vérifier et télécharger.",
   "file_size_exceed_skip": "La taille du fichier ne puede pas dépasser",
   "processing": "Traitement",
   "failed": "Échoué",
   "aliyun_storage_support": "Le stockage Aliyun prend en charge plus de formats",

  }
}